export function getData (state) {
  return state.userData
}

export function getToken (state) {
  return state.token
}

export function getAuthCheckStatus (state) {
  return state.checkAuth
}



// WEBPACK FOOTER //
// ./src/vuex/users/getters.js